module.exports = __webpack_public_path__ + "static/media/rosty.9c7f2d51.jpg";